export default __webpack_public_path__ + "static/media/bg.b50f3d0e.png";